export const authMethods = [
  {
    type: "patreon",
    label: "Увійти",
  },
];
